export const demoSteps = {
  intro: 0,
  demo: 1,
  outro: 2
};
